






























































































































































import Vue from 'vue'
import {
  defaultPosterImage,
  userAvatarImage,
  INSTRUCTOR_NAME_MAX_LENGTH
} from '../../helper/constants'
import { getMobileTheme } from '@/helper'
import UpsellModal from '@/components/common/UpsellModal.vue'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'
let openedWindow: Window | null
export default Vue.extend({
  components: { UpsellModal, BaseIcon },
  props: {
    upsellId: {
      type: String
    },
    offer: {
      type: Object
    },
    purchasedProductIds: {
      type: Array
    },
    notInCarousel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userAvatarImage,
      defaultPosterImage,
      isMobile: false,
      showModal: false,
      instructorNameLimit: INSTRUCTOR_NAME_MAX_LENGTH
    }
  },
  filters: {
    truncateText(text: string, MAX_LENGTH = 28): string {
      if (text?.length <= MAX_LENGTH) return text

      return text ? text?.slice(0, MAX_LENGTH) + '...' : ''
    }
  },
  computed: {
    courseData(): object {
      if (this.offer?.products?.length === 1) {
        const product = this.offer.products[0]
        return {
          title: product.title,
          posterImage: product.posterImage,
          description: this.$options.filters.truncateText(
            product.description,
            75
          ),
          instructorName:
            product.customizations?.instructorName || 'Instructor Name',
          instructorHeadshot: product.customizations?.instructorHeadshot
        }
      } else {
        return {
          title: this.offer.title,
          posterImage: this.offer.posterImage,
          description: this.$options.filters.truncateText(
            this.offer.description,
            75
          ),
          instructorName: 'Multiple Instructors',
          instructorHeadshot: null
        }
      }
    },
    backgroundImage(): string {
      return `url(${this.$options.filters.replaceBucketUrlWithCdnUrl(
        this.courseData.posterImage || defaultPosterImage
      )})`
    },
    newMobileScreens(): boolean {
      return this.$store.getters.newMobileScreens
    }
  },
  methods: {
    openUpsell() {
      if (this.newMobileScreens) {
        this.$router.push({
          name: 'upsell-bundle',
          params: {
            offer: this.offer,
            upsellId: this.upsellId,
            purchasedProductIds: this.purchasedProductIds,
            checkout: this.handleUpsellCheckout
          }
        })
        return
      }
      if (this.offer?.products?.length == 1) {
        this.handleUpsellCheckout()
      } else {
        this.showModal = true
        return
      }
    },
    handleUpsellCheckout() {
      const routeData = {
        name: 'in-app-upsell',
        params: {
          id: this.upsellId
        }
      }
      if (!this.newMobileScreens) {
        const routerData = this.$router.resolve(routeData)
        openedWindow = window.open(routerData.href, '_blank')
        const timer = setInterval(async () => {
          if (openedWindow.closed) {
            clearInterval(timer)
            window.location.reload()
          }
        }, 500)
      } else {
        this.$router.push(routeData)
      }
    },
    getMobileTheme
  }
})
